// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__RApha","title":"Dashboard_title__8Qg+N"};